import { formatNumbers, Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC, useEffect, useState } from 'react'

import useAccountCurrency from 'hooks/useAccountCurrency'
import useIsTestMode from 'hooks/useIsTestMode'
import { OrderType } from 'models/order'
import { BundleData } from 'views/Dashboard/Charts/OrdersChartConfig'

interface TotalPlacedAnalytics {
    totalPlacedOffsetValue: string
    totalPlacedOffsetQuantity: string
}

const Totals: FC<{ data: BundleData[]; analyticsType: OrderType }> = ({ data, analyticsType }) => {
    const [analytics, setAnalytics] = useState<TotalPlacedAnalytics>()
    const isTestMode = useIsTestMode()

    useEffect(() => {
        const quantity: number = data
            .map((d: BundleData) => d.timeseries[d.timeseries.length - 1].quantity)
            .reduce((a, b) => Number(a) + Number(b), 0)
        const value: number = data
            .map((d: BundleData) => d.timeseries[d.timeseries.length - 1].value)
            .reduce((a, b) => Number(a) + Number(b), 0)
        setAnalytics({
            totalPlacedOffsetQuantity: quantity.toString(),
            totalPlacedOffsetValue: value.toString(),
        })
    }, [data])

    const toCurrency = useAccountCurrency()

    return (
        <Box
            sx={{
                position: 'relative',
                // 320 is the buttons group fixed width
                width: 'calc(100% - 320px)',
                '.MuiTypography-root': {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                },
            }}
        >
            {analytics && (
                <Box>
                    <Text variant={'body2'} sx={{ mb: 1 }} color={`TextSecondary`}>
                        You have {analyticsType === OrderType.QUANTITY ? 'purchased' : 'spent'}
                    </Text>
                    {analyticsType === OrderType.QUANTITY ? (
                        <Text
                            variant={'h4'}
                            data-testid={`orders-total-quantity-${isTestMode ? 'test' : 'live'}`}
                        >
                            {' '}
                            {formatNumbers(
                                Math.round(Number(analytics.totalPlacedOffsetQuantity)),
                            )}{' '}
                            tCO₂
                        </Text>
                    ) : (
                        <Text variant={'h4'} data-testid={'orders-total-value'}>
                            {toCurrency?.(analytics.totalPlacedOffsetValue)}
                        </Text>
                    )}
                </Box>
            )}
        </Box>
    )
}

export default Totals
